
import { Vue, Component, Prop } from "vue-property-decorator";
import { makeNameQuery } from "@/helpers/queryHelperFunctions";

import GET_USERS from "@/apollo/autocomplete-queries/GetUsers.gql";
import MultiselectAvatar from "@/components/autocompleteMultiselects/MultiselectAvatar.vue";
import DropdownFilter from "@/components/filters/DropdownFilter.vue";
import TableAvatar from "@/components/table/TableAvatar.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";

import { Query_RootUserArgs, User } from "@/generated/graphql";
import getFullName from "@/helpers/getFullName";
import getInitials from "@/helpers/getInitials";
import Roles from "@/entities/Roles";
import S3Image from "@/components/common/s3-image.vue";
import {
  getInboxMultiselectAdminConditions,
  getInboxMultiselectManagerConditions,
} from "@/helpers/multiselect/inboxUserMultiselectConditions";

@Component({
  components: {
    DropdownFilter,
    MultiselectAvatar,
    LoadingOverlay,
    TableAvatar,
    S3Image,
  },
  apollo: {
    users: {
      query: GET_USERS,
      variables() {
        return this.usersAutocompleteFilter;
      },
      update: (data) => data.user,
    },
  },
  model: {
    prop: "user",
  },
})
export default class UsersSelect extends Vue {
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: String, required: true }) readonly currentUserRole!: string;
  @Prop({ type: String, required: true }) readonly companyId!: string;
  @Prop({ type: Number, default: 5 }) readonly limit!: number;
  @Prop({ default: undefined, type: Object }) readonly user?: User;

  watchUsers?: any = undefined;
  users?: User[] = undefined;
  usersSearchString: string = "";
  getInitials = getInitials;
  getFullName = getFullName;

  get defaultClasses(): string {
    return "avatar bg-badgeBlue inline-flex h-8 w-8 rounded-full items-center justify-center border border-primary customBg";
  }

  get usersAutocompleteFilter(): Query_RootUserArgs {
    return {
      where: {
        _and: [
          { id: { _nin: [this.currentUserId] } },
          makeNameQuery(this.usersSearchString),
          this.userRoleConditions,
        ],
      },
      limit: this.limit,
    };
  }

fullname({ given_name, family_name }: any): string {
    return `${given_name} ${family_name}`.trim();

  }

  initials({ given_name, family_name }: any): string {

    return getInitials(given_name, family_name)[0];

  }

  get userRoleConditions() {
    if (this.currentUserRole === Roles.ADMIN) {
      return getInboxMultiselectAdminConditions(this.currentUserId, this.companyId);
    }

    return getInboxMultiselectManagerConditions(this.currentUserId, this.companyId);
  }
}
